module.exports = __webpack_public_path__ + "img/7.b1f24201.jpg";